import { Close } from '@material-ui/icons'

export default (props) => <Close htmlColor='#F44336' {...props} />
